import { App_Url_New } from "../common/static";
import { axiosInstance } from "../lib/axiosInstance";

export async function bindquote(payload: Record<string, unknown>) {
  const response = await axiosInstance.post(App_Url_New.ApiEndPoint.bindQuote, payload);
  return response.data;
}
